import Column from './Column.component';

export default Column;